<template>
  <input type="password" hidden autocomplete="new-password">
  <!--   修改密码-->
  <div ref="modelDom" class="modal fade " id="findPasswordModal" tabindex="-1" aria-labelledby="findPasswordModalLabel" aria-hidden="true"
       data-bs-keyboard="false" data-bs-backdrop="static">
    <!--  <div class="modal" tabindex="-1">-->
    <div class="modal-dialog modal-dialog-centered ">
      <div class="modal-content">
        <div class="modal-header bg-primary position-relative text-white">
          <h1 class="modal-title  fw-bold  fs-5  text-center w-100" id="findPasswordLabel">修改密码</h1>
          <button type="button" class="btn-close btn-close-white position-absolute end-0 px-4 "  @click="closeMode"></button>
        </div>
        <div class="modal-body">
          <form class="needs-validation" novalidate ref="formDom" @submit.prevent="save" >
            <!--          手机号-->
            <div class="row w-100 g-2 g-sm-3 align-items-center ">
              <label for="phone" class="col-12 col-md-3 text-start">手机号</label>
              <div class="col-12 col-md-9">
                <input type="tel"
                       @input="phoneNumChange"
                       @change="phoneNumChange"
                       @click="phoneNumChange"
                       @focusout="phoneNumChange"
                       disabled
                       id="phone" name="phone" :value="tel" class="form-control" required>
                <div class="invalid-feedback">
                  请输入正确的手机号
                </div>
              </div>
            </div>
            <div class="row w-100 g-2 g-sm-3 align-items-center ">
              <label for="code" class="col-12 col-md-3 text-start ">验证码</label>
              <div class="col-12 col-md-9">
                <div class="input-group ">
                  <input type="text" id="code"
                         inputmode="numeric"
                         name="one-time-code"
                         autocomplete="one-time-code"
                         v-model="form.Code"  class="form-control"
                         aria-describedby="passwordHelpInline" required>
                  <span class="input-group-text d-flex align-items-center justify-content-center bg-white " id="basic-addon1">
                    <a class="text-primary point-curser" @click="sentCode" v-if="showCountState===1" :disabled="!phoneCurrent">
                      发送验证码
                    </a>
                    <a class="text-primary point-curser" @click="sentCode" v-if="showCountState===2" :disabled="!phoneCurrent">
                      正在发送
                      <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                    </a>
                    <a class="text-primary not-allowed-curser" v-if="showCountState===3">{{count}} s</a>
                  </span>
                </div>
              </div>
            </div>
            <div class="row w-100 g-2 g-sm-3 align-items-center ">
              <label for="inputPassword6" class="col-12 col-md-3 text-start">新密码</label>
              <div class="col-12 col-md-9">
                <input type="password" id="inputPassword6" v-model="form.Password" class="form-control"
                       aria-describedby="passwordHelpInline" required>
              </div>
            </div>
            <div class="row w-100 g-2 g-sm-3 align-items-center ">
              <label for="inputPassword6" class="col-12 col-md-3 text-start">确认密码</label>
              <div class="col-12 col-md-9">
                <input type="password" id="inputPassword6" v-model="form.PasswordConfirm" class="form-control"
                       aria-describedby="passwordHelpInline" required>
              </div>
            </div>
            <div class="row w-100 g-2 g-sm-3 mt-4 mb-2 align-items-center justify-content-center d-flex">
              <button class="col-10  col-sm-4 btn btn-md btn-primary me-2 py-2" type="submit"
                      :disabled="
                      !(form.Code &&form.Code.trim())
                      || !(form.Password &&form.Password.trim()) || !(form.PasswordConfirm &&form.PasswordConfirm.trim())|| loading
                  "
              >
                <span class="spinner-border spinner-border-sm" aria-hidden="true" v-if="loading"></span>
                确定
              </button>
              <button class="col-10 col-sm-4 btn btn-md btn-light py-2" type="button" value="Close!" @click="closeMode">
                取消
              </button>
            </div>
          </form>
        </div>

      </div>
    </div>
  </div>

</template>

<script setup>
import {defineEmits, defineProps, onMounted, onUnmounted, reactive, ref, watch} from "vue";
import {Modal} from "bootstrap";
import {showToast} from "@/utils/toast";
import {changeAccountPassword, sendSmsCode} from "@/api/login";
import {loginModelOpen, registModelOpen} from "@/utils/authCheck";
import store from "@/store";
const formDom = ref()
const count = ref(0)
let interval = null
const showCountState = ref(1) // 1可以发送验证码，2，号码正在验证中 3，已发送
const phoneCurrent = ref(false) // 电话号码格式正确
const loading = ref(false) // 提交按鈕
const props = defineProps({
  show: {
    default: false
  },
  tel:{
    default:""
  }
})
const form = reactive({
  Code:null,
  Password:null,
  PasswordConfirm:null
})

const emits = defineEmits({
  'update:show': (val) => {
    return val;
  },
  'closeMode': (val) => {
    return val;
  },
  'goLogin': (val) => {
    return val;
  }
})
const modelDom = ref() // 当前model
let modelRef; // model实例
const showModel = ()=>{
  if (!modelRef) {
    return
  }
  modelRef.show()
}

const hideModel = ()=>{
  if (!modelRef) {
    return
  }
  modelRef.hide()
}
// 修改的模块
watch(() => props.show,(n,o) => {
  if(n){
    showModel()
  }else{
    hideModel()
  }
},{ deep: true})
//关闭model
const closeMode = (event)=>{
  event.preventDefault();
  event.stopPropagation();
  emits('update:show', false);
}


// 验证输入的电话号码
const phoneNumChange = ()=>{
  if(!props.tel || !props.tel.trim()){
    phoneCurrent.value = false
    return false
  }
  var phoneReg = /^1[3-9]\d{9}$/
  if(phoneReg.test(props.tel)){
    phoneCurrent.value = true
    return true
  }else{
    phoneCurrent.value = false
    return false
  }
}
//提交
const save = async (event)=>{
  event.preventDefault();
  event.stopPropagation();
  // emits('update:show', false); // 关闭修改密码的框
  // store.dispatch("loginModel/loginOut") // 退出登录
  loading.value = true
  const res = await changeAccountPassword({...form,Tel:props.tel})
  loading.value = false
  if(res.err_code===0){
    showToast("success","密码修改成功")
    emits('update:show', false); // 关闭修改密码的框
    // store.dispatch("loginModel/loginOut") // 退出登录
    // loginModelOpen(true) // 打开登录框
    //  关闭注册框，打开登录框
  }else{
    showToast("danger",res.err_msg || "密码修改失败")
  }
}

onMounted(()=>{
  modelRef = new Modal(modelDom.value)
  if(props.show){
    showModel()
  }else{
    hideModel()
  }
})
const sentCode =async ()=>{
  if(phoneNumChange()){
    showCountState.value = 2
    // 2，发送验证码
    const cres = await sendSmsCode({tel:props.tel,Mode:1})
    if(cres.err_code===0){ // 已经发送
      showCountState.value = 3
      showToast("success","验证码发送成功")
      startCount()
    }else{
      showCountState.value = 1
      return showToast("danger",cres.err_msg || "获取验证码失败")
    }
    // startCount()
  }else{
    return showToast("warning","请输入正确的电话号码")
  }
}
const startCount = ()=>{
  count.value = 60
  interval = setInterval(()=>{
    count.value = count.value - 1
    if(count.value===0){
      clearInterval(interval)
      showCountState.value = 1
    }
  },1000)
}
onUnmounted(()=>{
  interval && clearInterval(interval)
})

</script>

<style scoped lang="scss">
.form-control{
  height: 3rem;
}
.img-box > img{
  width: 100%;
  height: 100%;
  object-fit: fill; /* 保持图片比例且填满容器 */
}
.input-group{
  input{
    border-right: none !important;
  }
  .input-group-text{
    //width: 100px;
  }
}
</style>
